import "../../styles.css";
import "./../Footer/footer.css";
import Footer from "./../Footer/Footer";
import Header from "./../Header/Header";
import Thumbnail from "./../Thumbnail/Thumbnail";
import "./../Thumbnail/thumbnail.css";
import "./../Thumbnail/thumbnail.css";
import "./../Footer/footer.css";
import dataviz from "../../images/dataviz-streetfood.png";
import toys from "../../images/childhood-full.png";
import placeholder from "../../images/placeholder.png";
import cattogirl from "../../images/yukaicourse.gif";
import golf from "../../images/golf-starterpack-full.png";
import learn from "../../images/learn-thumbnail.png";
import strava from "../../images/strava-redesign.png";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div>
      <Header />
      <div className="project-row">
        <Link to="/strava" relative="/strava">
          <Thumbnail
            thumbnail={strava}
            title="Strava Redesign"
            description="Reimagining the group running experience"
            tag1="Mobile UX/UI"
            tag2="Useful School"
          />
        </Link>
        <Link to="/nostalgia" relative="/nostalgia">
          <Thumbnail
            thumbnail={toys}
            title="Childhood Nostalgia"
            description="Month-long nostalgia project revisiting favorite childhood toys"
            tag1="3D"
            tag2="Personal"
          />
        </Link>
      </div>
      <div className="project-row">
        <Link to="/cat" relative="/cat">
          <Thumbnail
            thumbnail={cattogirl}
            title="Cat to Girl"
            description="Handrawn Cel-Animation Loop"
            tag1="Animation"
            tag2="Personal"
          />
        </Link>
        <Link to="/learning" relative="/learning ">
          <Thumbnail
            thumbnail={learn}
            title="Learning Playlists"
            description="A web platform for sharing curated learning paths in the community"
            tag1="Web UX/UI"
            tag2="Personal"
          />
        </Link>
      </div>
      <div className="project-row">
        <Link to="/food" relative="/food">
          <Thumbnail
            thumbnail={dataviz}
            title="Taiwan Street Food"
            description="Interactive data viz showcasing popular Taiwanese street snacks"
            tag1="3D"
            tag2="Collab"
          />
        </Link>
        <Link to="/golf" relative="/golf">
          <Thumbnail
            thumbnail={golf}
            title="Golf Starter Pack"
            description="3D Illustrations Card"
            tag1="3D"
            tag2="Personal"
          />
        </Link>
      </div>
      <Footer />
    </div>
  );
}
